import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { LoadingState } from '../../../../../types/loading-state';
import { isNonEmptyArray } from '../../../../../utils/array-utils';
import { createFetchedData } from '../../../../../utils/fetched-data/create-fetched-data';
import { createFetchedDataRecord } from '../../../../../utils/fetched-data/create-fetched-data-record';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../../utils/load-data-from-api';
import { updateObject } from '../../../../../utils/object-utils';
import { getMember } from '../../../selectors/member/get-member';
import { getMemberTransactions } from '../../../selectors/member/transactions/get-member-transactions';
import { memberHasMoreTransactionResults } from '../../../selectors/member/transactions/member-has-more-transaction-results';
import { loyaltyDomainStore } from '../../../store';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
import { assertIsMemberSignedIn } from '../../../utils/assert-is-member-signed-in';
export const loadMemberTransactions = async (query) => {
    assertIsMemberSignedIn(getMember(), 'Cannot load member transactions');
    if (isNonEmptyArray(getMemberTransactions()) && !memberHasMoreTransactionResults())
        return;
    const state = temporaryLoyaltyDomainStore.data.memberTransactions;
    const cacheDuration = getCacheDuration('member');
    if (state.loadingState === LoadingState.Success)
        return await loadMoreTransactions(query, cacheDuration);
    return await loadDataFromApi({
        api: () => ocapiClient.instance.v1.loyalty.members.transactions.get(query),
        state,
        cacheDuration,
        reloadCachedData: true,
        onSuccess
    });
};
const loadMoreTransactions = async (query, cacheDuration) => {
    const paginatedResultSet = await ocapiClient.instance.v1.loyalty.members.transactions.get(query);
    return runInAction(() => {
        const data = onSuccess(paginatedResultSet, cacheDuration);
        temporaryLoyaltyDomainStore.data.memberTransactions = createFetchedData(data, cacheDuration);
        return data;
    });
};
const onSuccess = (response, cacheDuration) => {
    const { results, hasMoreResults, relatedData } = response;
    const existingTransactions = getMemberTransactions();
    assignRelatedData(relatedData, cacheDuration);
    return { results: [...existingTransactions, ...results], hasMoreResults };
};
const assignRelatedData = (relatedData, cacheDuration) => {
    const { sites, films, items, showtimes, ticketTypes, balanceTypes } = relatedData;
    const state = loyaltyDomainStore.data;
    updateObject(state.sitesById, createFetchedDataRecord(sites, 'id', cacheDuration));
    updateObject(state.filmsById, createFetchedDataRecord(films, 'id', cacheDuration));
    updateObject(state.itemsById, createFetchedDataRecord(items, 'id', cacheDuration));
    updateObject(state.showtimesById, createFetchedDataRecord(showtimes, 'id', cacheDuration));
    updateObject(state.ticketTypesById, createFetchedDataRecord(ticketTypes, 'id', cacheDuration));
    updateObject(state.balanceTypesById, createFetchedDataRecord(balanceTypes, 'id', cacheDuration));
};
